import { getDrawingsHistory } from "../../helpers/apis";
import {
    setLoading,
    setDrawingsHistory,
    setError,
} from "./reducer";

// Fetch drawings history
export const fetchDrawingsHistory = (params = {}) => async (dispatch) => {
    try {
        dispatch(setLoading(true));
        const response = await getDrawingsHistory(params);
        if (response.status === 1) {
            dispatch(setDrawingsHistory(response));
        } else {
            dispatch(setError(response.message || "Failed to fetch drawings history"));
        }
    } catch (error) {
        dispatch(setError(error.message));
    } finally {
        dispatch(setLoading(false));
    }
};
